/*
 * Application Insights JavaScript SDK - Common, 2.7.6
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Data struct to contain only C section with custom fields.
 */
var Base = /** @class */ (function () {
    function Base() {
    }
    return Base;
}());
export { Base };
//# sourceMappingURL=Base.js.map